module.exports = "#slider{\r\n  width: 100%;\r\n  height: 500px;\r\n  max-width: 1920px;\r\n  margin: auto;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/header/slider/slider.component.css
// module id = ./src/app/components/header/slider/slider.component.css
// module chunks = main